export const capitalize = string => {
  return string?.charAt(0)?.toUpperCase() + string?.slice(1) || null
}

export const snakeToCamel = string => {
  return string.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase())
}
